import { SEED_ACHIEVEMENTS } from '../data/verifiedQuestions.ts';

// Build a fast lookup map for known seeded achievements
const SEEDED_TITLE_MAP: Record<string, string> = {};
if (Array.isArray(SEED_ACHIEVEMENTS)) {
  for (const item of SEED_ACHIEVEMENTS) {
    if (item.code && item.title) {
      SEEDED_TITLE_MAP[item.code] = item.title;
    }
  }
}

/**
 * Formats an achievement ID into a readable Title Case display name.
 * 1. Checks optional localized map / overrides first.
 * 2. Checks seeded achievement title dictionary.
 * 3. Falls back to replacing "_" and "-" with spaces, lowercasing, and capitalizing each word.
 *
 * Example: 'BIBLE_SCHOLAR' -> 'Bible Scholar'
 */
export function formatAchievementName(
  id: string | null | undefined,
  localizedMap?: Record<string, string>
): string {
  if (!id || typeof id !== 'string') return '';
  const trimmed = id.trim();
  if (!trimmed) return '';

  // 1. Localized custom display names
  if (localizedMap && localizedMap[trimmed]) {
    return localizedMap[trimmed];
  }

  // 2. Seeded display names if present
  if (SEEDED_TITLE_MAP[trimmed]) {
    return SEEDED_TITLE_MAP[trimmed];
  }

  // 3. Fallback Title Case formatter
  return trimmed
    .replace(/[-_]+/g, ' ')
    .trim()
    .toLowerCase()
    .split(/\s+/)
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}
